module.exports = __webpack_public_path__ + "static/9-0d41d5d3b3b5b31fb7f746c4a32282d8.jpeg";